export const DEMO_PASSWORD = 'meridian2025';

export const ZOOM_LEVELS = [75, 100, 125, 150, 175, 200];
export const DEFAULT_ZOOM = 125;

export const tabs = [
  { id: 'summary', label: 'Summary' },
  { id: 'income', label: 'Income' },
  { id: 'balance', label: 'Balance' },
  { id: 'cashflow', label: 'Cash Flow' },
];

export const MIN_WIDTH = 420;
export const MAX_WIDTH = 700;
export const DEFAULT_WIDTH = 440;
